import { render, staticRenderFns } from "./PsPatientSubscriptionHistoryItem.vue?vue&type=template&id=21bdb897&scoped=true&"
import script from "./PsPatientSubscriptionHistoryItem.vue?vue&type=script&lang=js&"
export * from "./PsPatientSubscriptionHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientSubscriptionHistoryItem.vue?vue&type=style&index=0&id=21bdb897&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bdb897",
  null
  
)

export default component.exports